import Vue from 'vue';
import { i18n } from '@/plugins/i18n';
import toastr from 'toastr';
import { doAsync } from '@/utils/async';
import * as actionsTypes from './action-types';
import * as mutationsTypes from './mutation-types';


export default {

  /** Refresh team's notifications */
  async [actionsTypes.FETCH_NOTIFICATIONS](store) {
    return doAsync(store, {
      config: {
        method: 'get',
        url: '/server/notifications',
      },
      mutationTypes: mutationsTypes.GET_NOTIFICATIONS,
      callback: response => (response.data instanceof Array ? response.data : []),
    });
  },

  /** Set notifications' 'read' state to 1 */
  async [actionsTypes.READ_NOTIFICATIONS](store, payload) {
    return doAsync(store, {
      config: {
        method: 'post',
        url: '/server/notifications',
        data: payload,
      },
      mutationTypes: mutationsTypes.GET_NOTIFICATIONS,
      callback: response => (response.data instanceof Array ? response.data : []),
    });
  },
};
